import React, { useState } from 'react';
import { IconSend, IconCheck, IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const NewProjects = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    projectDescription: '',
    preferredMeetingTime: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      // Call the cloud function to send email and store inquiry
      const cloudFunctionUrl = 'https://us-central1-southern-list-468215-m7.cloudfunctions.net/sendProjectInquiry';

      const response = await fetch(cloudFunctionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to submit inquiry');
      }

      setSubmitted(true);
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('There was an error submitting your request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <main className="ub-new-projects-page">
        <div className="ub-new-projects-container">
          <div className="ub-success-state">
            <div className="ub-success-icon">
              <IconCheck size={48} />
            </div>
            <h1>Thank You!</h1>
            <p>
              We've received your project inquiry and will be in touch within 1-2 business days
              to discuss how we can help bring your vision to life.
            </p>
            <button
              className="ub-btn-back-home"
              onClick={() => navigate('/')}
            >
              <IconArrowLeft size={20} />
              <span>Back to Home</span>
            </button>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="ub-new-projects-page">
      <div className="ub-new-projects-container">
        <div className="ub-form-header">
          <h1>Start a Project</h1>
          <p>
            Tell us about your idea and we'll get back to you to discuss how we can help.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="ub-project-form">
          <div className="ub-form-group">
            <label htmlFor="name">Name <span className="ub-required">*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your full name"
            />
          </div>

          <div className="ub-form-group">
            <label htmlFor="email">Email <span className="ub-required">*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="ub-form-group">
            <label htmlFor="projectDescription">
              What Can We Build for You? <span className="ub-required">*</span>
            </label>
            <textarea
              id="projectDescription"
              name="projectDescription"
              value={formData.projectDescription}
              onChange={handleChange}
              required
              placeholder="Describe your project idea, goals, and any specific requirements..."
              rows={6}
            />
          </div>

          <div className="ub-form-group">
            <label htmlFor="preferredMeetingTime">
              Preferred Meeting Time <span className="ub-optional">(Optional)</span>
            </label>
            <input
              type="text"
              id="preferredMeetingTime"
              name="preferredMeetingTime"
              value={formData.preferredMeetingTime}
              onChange={handleChange}
              placeholder="e.g., Weekday mornings, Tuesday/Thursday afternoons"
            />
          </div>

          {error && (
            <div className="ub-form-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="ub-btn-submit"
            disabled={submitting}
          >
            {submitting ? (
              <span>Submitting...</span>
            ) : (
              <>
                <span>Submit Inquiry</span>
                <IconSend size={20} />
              </>
            )}
          </button>
        </form>
      </div>
    </main>
  );
};

export default NewProjects;
